var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.092,
    height: 11.945,
    viewBox: "0 0 11.092 11.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__np_avatar_2323871_000000",
    fill: "#212631",
    d: "M14.921 6.25a2.986 2.986 0 1 0 2.986 2.986 2.993 2.993 0 0 0-2.986-2.986zm0 .853a2.133 2.133 0 1 1-2.133 2.133A2.126 2.126 0 0 1 14.921 7.1zm-2.56 5.973a2.989 2.989 0 0 0-2.986 2.986V18.2h11.092v-2.138a2.989 2.989 0 0 0-2.986-2.986zm0 .853h5.119a2.119 2.119 0 0 1 2.133 2.133v1.28h-9.385v-1.28a2.119 2.119 0 0 1 2.133-2.133z",
    transform: "translate(-9.375 -6.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.b63425a8d68928d054291e78ac6750c7.svg";
export { ForwardRef as ReactComponent };